import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { EntityForm } from "@/components/v2/entity-form";
import { useCreateCrew } from "@/hooks/use-api";
import { CREW_FIELDS, type CrewFormValues } from "./crew-form-config";

export default function V2CrewCreatePage() {
  const navigate = useNavigate();
  const createCrew = useCreateCrew();
  const [error, setError] = useState<string | null>(null);

  async function onSubmit(values: CrewFormValues) {
    setError(null);
    try {
      await createCrew.mutateAsync(values as Record<string, unknown>);
      toast.success("Crew created");
      navigate("/crews");
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : "Could not create the crew — check the fields and try again.",
      );
    }
  }

  return (
    <EntityForm<CrewFormValues>
      title="Create crew"
      breadcrumbs={[{ label: "Crews", href: "/crews" }, { label: "New" }]}
      defaultValues={{}}
      fields={CREW_FIELDS}
      submitLabel="Create crew"
      onSubmit={onSubmit}
      cancelHref="/crews"
      error={error}
      isSubmitting={createCrew.isPending}
    />
  );
}
